module.exports = __webpack_public_path__ + "static/img/gongzhonghao.0fd0761d.png";